import { Component, OnInit } from '@angular/core';
import { BpgMembershipService } from '../bpg-membership.service';
import { MembershipFormData, Leadership, LandingDTOModel, FilterModel } from "../../bpg-common/services/data.services";
import { Router } from '@angular/router';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

import { EnvironmentConfiguration } from 'src/app/environment/services/environment.configuration';

@Component({
  selector: 'app-bpg-membership-preview',
  templateUrl: './bpg-membership-preview.component.html',
  styleUrls: ['./bpg-membership-preview.component.css']
})
export class BpgMembershipPreviewComponent implements OnInit {

  bpg: any[] = [];
  skills: any[] = [];
  areaOfImpact: any[] = [];
  formData: MembershipFormData[];
  firstCategory: any[] = [];
  secondCategory: any[] = [];
  thirdCategory: any[] = [];
  demographics: any[] = [];
  savedData: any = JSON.parse(sessionStorage.getItem('MembershipData'));
  selectedSite: any;
  selectedBpg: any[] = [];
  selectedInterest: any[] = [];
  selectedSkills: any[] = [];
  selectedDemographics: any[] = [];
  chair: boolean;
  voiceChair: boolean;
  communicationsChair: boolean;
  financeChair: boolean;
  otherSKills = "";
  membershipDetails: any[] = [];
  message: string;

  selectedLeadership: Leadership = new Leadership();
  finalFormdata: FinalFormdata[] = [];

  areaOfImpactIdsArray: number[] = [];
  bpgIdsArray: number[] = [];
  //demographicIdsArray: number[] = [];
  isLeadershipChecked: LeadershipFormObject = new LeadershipFormObject();
  skillIdsArray: number[] = [];
  userId = 1;
  otherSkills = "";
  alertSuccess: boolean;
  loginData: any = JSON.parse(localStorage.getItem('loginData'));
  loginUserId: any[] = [];
  memberDetails: any;
  savedMembershipForm: any = JSON.parse(sessionStorage.getItem('previousMembershipDetails'));
  msg1: string;
  msg2: string;
  previewMethod: string;
  landingDTOModel: LandingDTOModel = new LandingDTOModel();
  filter: FilterModel = new FilterModel();
  siteId1: any = localStorage.getItem('userSiteId');
  status: any = localStorage.getItem('status');
  defaultSiteLocation = '';
  virtualBpg: boolean;
  siteId: number;
  bpgList : any; 
  chairs :  any = [];
  viceChairs : any = []  ;
  communicationsChairs: any= [] ;
  financeChairs: any  = [];
  corporateType: string;
  isCorporateUser = false;

  public DisableSkills = true;
  public DisableBpg = true;
  public DisableLeadership = true;
  public DisableAreaOfImpact = true;
  public DisableDemographics = true;
  public checked = false;

  /** @class BpgMembershipPreviewComponent
* @constructor
*/
  constructor(private readonly membershipService: BpgMembershipService,
    private readonly  router: Router,
    private readonly spinnerService: Ng4LoadingSpinnerService,
    
    private readonly environment: EnvironmentConfiguration
  ) { }

  ngOnInit() {
    if (this.environment.envName === 'dev' || this.environment.envName === 'qa' || this.environment.envName === 'prod') {
              if (localStorage.getItem('loginData')=== null || localStorage.getItem('loginData')=== undefined) {

        this.router.navigate(['/log-out']);
      }
    }
    this.corporateType = (this.loginData.corporatePartnerType !== null && this.loginData.corporatePartnerType !== undefined) ? this.loginData.corporatePartnerType.trim() : '';
    if (this.corporateType.toUpperCase() === "CONTINGENT" || this.corporateType.toUpperCase() === "TECHNICAL CONTRACTOR") {
      this.isCorporateUser = true;
    }
    this.memberDetails = this.loginData;

    this.loginUserId = this.loginData.userId;
    this.defaultSiteLocation = this.loginData.site.siteName;
    this.formData = [];
    this.getBpgDetails();

    this.membershipService.getSkills().subscribe(data => {
      this.skills = data;

      if (this.savedData[0].skillsFormData !== undefined) {
        if (this.savedData[0].skillsFormData.length > 0) {
          for (let i = 0, len = this.skills.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].skillsFormData.length; j < len; j++) {
              if (this.skills[i].skillId === this.savedData[0].skillsFormData[j].skillId) {
                this.skills[i].checked = true;
                this.selectedSkills.push(this.skills[i]);
              }
            }
          }
        }
        else if (localStorage.getItem('oneSkill') === 'true') {
          if (this.savedMembershipForm.otherSkills !== this.savedData[0].otherSkillsFormData) {
            this.otherSKills = this.savedData[0].otherSkillsFormData;
          } else {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          this.selectedSkills.push(this.savedData[0].skillsFormData);
        }
        else if (this.savedMembershipForm.skillIds.length > 0) {
          if (this.savedMembershipForm.otherSkills != null) {
            this.otherSKills = this.savedMembershipForm.otherSkills;
          }
          for (let i = 0, len = this.skills.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.skillIds.length; j < len; j++) {
              if (this.skills[i].skillId === this.savedMembershipForm.skillIds[j]) {
                this.skills[i].checked = true;
                this.selectedSkills.push(this.skills[i]);
              }
            }
          }
        }
        else if (this.savedMembershipForm.otherSkills != null) {
          this.otherSKills = this.savedMembershipForm.otherSkills;
        }
      }

    })
    this.membershipService.getAreasOfImpact().subscribe(data => {
      this.areaOfImpact = data;

      const groupByName = {};
      this.areaOfImpact.forEach(function (a) {
        groupByName[a.category] = groupByName[a.category] || [];
        groupByName[a.category].push({ areaOfImpactId: a.areaOfImpactId, subCategory: a.subCategory });

      });

      this.firstCategory = groupByName["Work Force Inclusion"];
      this.secondCategory = groupByName["Work Place Engagement"];
      this.thirdCategory = groupByName["Market Place Connection"];
      if (this.savedData[0].interestFormData !== undefined) {
        if (this.savedData[0].interestFormData.length > 0) {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.firstCategory[i].checked = true;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.secondCategory[i].checked = true;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }

          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedData[0].interestFormData.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId === this.savedData[0].interestFormData[j].areaOfImpactId) {
                this.thirdCategory[i].checked = true;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
        }
        else if (this.savedData[0].interestFormData.length === 0 && this.status === 'true') {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            this.firstCategory[i].checked = false;
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            this.secondCategory[i].checked = false;
          }
          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            this.thirdCategory[i].checked = false;
          }
        }
        else if (this.savedMembershipForm.areaOfImpactIds.length > 0) {
          for (let i = 0, len = this.firstCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.firstCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.firstCategory[i].checked = true;
                this.selectedInterest.push(this.firstCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.secondCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.secondCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.secondCategory[i].checked = true;
                this.selectedInterest.push(this.secondCategory[i]);
              }
            }
          }
          for (let i = 0, len = this.thirdCategory.length; i < len; i++) {
            for (let j = 0, len = this.savedMembershipForm.areaOfImpactIds.length; j < len; j++) {
              if (this.thirdCategory[i].areaOfImpactId === this.savedMembershipForm.areaOfImpactIds[j]) {
                this.thirdCategory[i].checked = true;
                this.selectedInterest.push(this.thirdCategory[i]);
              }
            }
          }
        }
      }

    })

    this.chair = null;
    this.voiceChair = null;
    this.communicationsChair = null;
    this.financeChair = null;

    if (this.savedData[0].leadershipFormData !== undefined) {
      if (this.savedData[0].leadershipFormData.chair !== undefined) {
        this.chair = this.savedData[0].leadershipFormData.chair;
      }
      if (this.savedData[0].leadershipFormData.viceChair !== undefined) {
        this.voiceChair = this.savedData[0].leadershipFormData.viceChair;
      }
      if (this.savedData[0].leadershipFormData.communicationsChair !== undefined) {
        this.communicationsChair = this.savedData[0].leadershipFormData.communicationsChair;
      }
      if (this.savedData[0].leadershipFormData.financeChair !== undefined) {
        this.financeChair = this.savedData[0].leadershipFormData.financeChair;
      }
    }
    else if (this.savedMembershipForm.leadershipDetails != null) {
      this.chair = this.savedMembershipForm.leadershipDetails.isChair;
      this.voiceChair = this.savedMembershipForm.leadershipDetails.isViceChair;
      this.communicationsChair = this.savedMembershipForm.leadershipDetails.isCommunicationChair;
      this.financeChair = this.savedMembershipForm.leadershipDetails.isFinanceChair;

    }

    if (this.savedData[0].otherSkillsFormData !== undefined) {
      this.otherSKills = this.savedData[0].otherSkillsFormData;
    } else {
      this.otherSKills = null;
    }
  }

  /** to select the checkbox
   * @class BpgMembershipPreviewComponent
   * @method toggleCheckboxBpg
   */
  toggleCheckboxBpg(event, data) {  
    
    if (event.target.checked) {
      this.selectedBpg.push(data);
      for (let i = 0 ; i < this.bpg.length ; i++)
      {
 
       if( this.bpg[i].bpgName === data.bpgName)
       {
         this.bpg[i] = Object.assign(this.bpg[i], {
           'showLeadership' : true,
         })
     
 }}
    
      for(let j = 0 ; j < this.selectedBpg.length ; j++)
      {
        if( this.selectedBpg[j].bpgName === data.bpgName){
          this.selectedBpg[j] = Object.assign(this.selectedBpg[j], {
            chairs : false,communicationsChairs: false , financeChairs :false, viceChairs : false
  })
        }
      }
     
 
   } else {
      const index: number = this.selectedBpg.indexOf(data);
      if (index !== -1) {
      

        this.selectedBpg.splice(index, 1);
       for (let i = 0; i < this.bpg.length ; i++){
        if(this.bpg[i].bpgName === data.bpgName)
        {
         this.bpg[i] = Object.assign(this.bpg[i], {
            'showLeadership' : false,
      }) }
   
     
      }
     
      }
    }

  }

  /** to select the checkbox
   * @class BpgMembershipPreviewComponent
   * @method toggleCheckboxAreaOfImpact
   */
  toggleCheckboxAreaOfImpact(event, data) {
    if (event.target.checked) {
      this.selectedInterest.push(data);

    } else {
      const index: number = this.selectedInterest.indexOf(data);
      if (index !== -1) {
        this.selectedInterest.splice(index, 1);
      }
    }

  }

  /** to select cancel
    * @class BpgMembershipPreviewComponent
    * @method cancelClick
    */
  cancelClick() {
    localStorage.setItem('status', 'false');
    this.previewMethod = "navigate";
    this.msg1 = " Are you sure you want to leave this page ? Changes you made may not be saved.";
  }

  /** to select confirm
    * @class BpgMembershipPreviewComponent
    * @method saveClick
    */
  saveClick() {
    localStorage.setItem('status', 'false');
    localStorage.setItem('oneSkill', 'false');
    this.previewMethod = "saveMembershipForm";
    this.msg1 = " Do you want to submit Membership form ?";
  }

  navigate() {
    this.router.navigate(['membership']);
    sessionStorage.removeItem("MembershipData");

    window.scrollTo(0, 0);
  }

  assignroles(event,data)

  {
    const bpgName = data.bpgName;
    if(event.target.checked)
    {
      for (const b of this.selectedBpg)
      {
        if(bpgName === b.bpgName)
        {
        if(this.chairs[bpgName]){
          b.chairs = true;}
        if(this.viceChairs[bpgName]){
          b.viceChairs = true;}
        if(this.communicationsChairs[bpgName]){
          b.communicationsChairs = true;}
        if(this.financeChairs[bpgName]){
          b.financeChairs = true;}
        }
      }
    }
    
    else{
      for (const b1 of this.selectedBpg)
      {
        if(bpgName === b1.bpgName)
        {
        if(!this.chairs[bpgName]){
          b1.chairs = false;}
        if(!this.viceChairs[bpgName]){
          b1.viceChairs = false;}
        if(!this.communicationsChairs[bpgName]){
          b1.communicationsChairs = false;}
        if(!this.financeChairs[bpgName]){
          b1.financeChairs = false;}
        }
      }
     
    }
    }

  /** to select the checkbox
  * @class BpgMembershipPreviewComponent
  * @method toggleCheckboxSkill
  */
  toggleCheckboxSkill(event, data) {
    if (event.target.checked) {
      this.selectedSkills.push(data);

    } else {
      const index: number = this.selectedSkills.indexOf(data);
      if (index !== -1) {
        this.selectedSkills.splice(index, 1);
      }
    }

  }
  /** To async the service call to get the bpg list with selected bpgs
   * @class BpgMembershipPreviewComponent
   * @method getBpgDetails
   */
  getBpgDetails() {
    if (this.savedData[0].virtualBpg && this.defaultSiteLocation !== 'DFLT') {
      this.getVirtualBpgs();
    } else {
      this.getBpgs();
    }
  }

  /** To async the service call to get the bpg list
   * @class BpgMembershipPreviewComponent
   * @method getBpgs
   */
  getBpgs() {
    if (this.savedData[0].siteFormData !== undefined) {
      this.selectedSite = this.savedData[0].siteFormData;
      this.filter.siteId = String(this.selectedSite.siteId);
      this.landingDTOModel.filter = this.filter;
    }
    this.membershipService.getAllBpg(this.landingDTOModel).subscribe(data => {
      this.bpg = data;
      this.getSelectedBpgs();
    });
  }

  /** To async the service call to get the bpg list of default site
   * @class BpgMembershipPreviewComponent
   * @method getBpgs
   */
  getVirtualBpgs() {
    if (this.savedData[0].siteFormData !== undefined) {
      this.selectedSite = this.savedData[0].siteFormData;
      this.filter.siteId = String(this.selectedSite.siteId);
    }
    const params = `${this.filter.siteId}/${this.siteId1}/${this.loginData.userId}`;
    console.info(params);
    this.membershipService.getAllVirtualBpg(params).subscribe(data => {
      this.bpg = data;
      this.getSelectedBpgs();
    });
  }


  /** To async the service call to get the selected bpg list
   * @class BpgMembershipPreviewComponent
   * @method getSelectedBpgs
   */
  getSelectedBpgs() {
    if (this.savedData[0].bpgFormData !== undefined) {
      if (this.savedData[0].bpgFormData.length > 0) {
        for (let i = 0, len = this.bpg.length; i < len; i++) {
          for (let j = 0, len = this.savedData[0].bpgFormData.length; j < len; j++) {
            if (this.bpg[i].bpgId === this.savedData[0].bpgFormData[j].bpgId) {
              this.bpg[i].checked = true;
              this.bpg[i].showLeadership = true;
              this.bpg[i].chairs = this.savedData[0].bpgFormData[j].chairs;
              this.chairs[this.bpg[i].bpgName] =  this.bpg[i].chairs;
              this.bpg[i].viceChairs = this.savedData[0].bpgFormData[j].viceChairs;
              this.viceChairs[this.bpg[i].bpgName] =  this.bpg[i].viceChairs;
              this.bpg[i].communicationsChairs = this.savedData[0].bpgFormData[j].communicationsChairs;
              this.communicationsChairs[this.bpg[i].bpgName] =  this.bpg[i].communicationsChairs;
              this.bpg[i].financeChairs = this.savedData[0].bpgFormData[j].financeChairs;
              this.financeChairs[this.bpg[i].bpgName] =  this.bpg[i].financeChairs;
              this.selectedBpg.push(this.bpg[i]);
            }
          }
        }
      }
    }
  }






  /**
    * // To disable or to enable selected division
    * @class BpgMembershipPreviewComponent
    * @method changeFun
    */

  public changeFun(type) {
    switch (type) {
      case 'DisableLeadership': this.DisableLeadership = false;
        break;
      case 'DisableBpg': this.DisableBpg = false;
        break;
      case 'DisableSkills': this.DisableSkills = false;
        break;
      case 'DisableAreaOfImpact': this.DisableAreaOfImpact = false;
        break;
      
    }
  }

  /** to save all selected data
   * @class BpgMembershipPreviewComponent
   * @method saveMembershipForm
   */
  saveMembershipForm() {
    this.spinnerService.show();
    this.selectedLeadership.chair = this.chair;
    this.selectedLeadership.viceChair = this.voiceChair;
    this.selectedLeadership.communicationsChair = this.communicationsChair;
    this.selectedLeadership.financeChair = this.financeChair;

    this.formData.push({ virtualBpg: this.savedData[0].virtualBpg, siteFormData: this.selectedSite, bpgFormData: this.selectedBpg, interestFormData: this.selectedInterest, skillsFormData: this.selectedSkills, leadershipFormData: this.selectedLeadership, otherSkillsFormData: this.otherSKills })
    

    this.virtualBpg = this.formData[0].virtualBpg;
    this.siteId = this.formData[0].siteFormData.siteId;
    this.formData[0].bpgFormData.forEach(bpg => {
      this.bpgIdsArray.push(bpg.bpgId)
    });
    this.formData[0].interestFormData.forEach(interest => {
      this.areaOfImpactIdsArray.push(interest.areaOfImpactId);
    });
   
    this.formData[0].skillsFormData.forEach(skills => {
      this.skillIdsArray.push(skills.skillId);
    });

    this.isLeadershipChecked.isChair = this.formData[0].leadershipFormData.chair;
    this.isLeadershipChecked.isViceChair = this.formData[0].leadershipFormData.viceChair;
    this.isLeadershipChecked.isCommunicationChair = this.formData[0].leadershipFormData.communicationsChair;
    this.isLeadershipChecked.isFinanceChair = this.formData[0].leadershipFormData.financeChair;
    this.otherSKills = this.formData[0].otherSkillsFormData;
   for(const b3 of this.selectedBpg)
   {
    b3.createdBy = this.loginUserId;
    b3.modifiedBy = this.loginUserId;
   }
    this.finalFormdata.push({
      areaOfImpactIds: this.areaOfImpactIdsArray, bpgIds: this.bpgIdsArray,
      skillIds: this.skillIdsArray, isLeadershipChecked: this.isLeadershipChecked,
      otherSkill: this.otherSKills, userId: this.loginUserId,
      siteId: this.siteId, virtualMembership: this.virtualBpg,
      selectedBpg : this.selectedBpg
    });

    this.membershipService.saveMembershipForm(this.finalFormdata[0]).subscribe(_data => {
      setTimeout(function () {
        this.spinnerService.hide();
        this.router.navigate(['/membership/preview-success']);
      }.bind(this), 3000);

    })
  }

}
export class FinalFormdata {
  areaOfImpactIds: number[];
  bpgIds: number[];
  isLeadershipChecked: LeadershipFormObject;
  skillIds: number[];
  userId: any;
  otherSkill: string;
  virtualMembership: boolean;
  siteId: number;
  selectedBpg : any;
}
export class LeadershipFormObject {
  isChair: boolean;
  isCommunicationChair: boolean;
  isFinanceChair: boolean;
  isViceChair: boolean;
}
